export default "__VITE_ASSET__B6_WE1$P__"